/** Logo oficial del programa (CDN TNO). */
export const EN_PRODUCCION_CON_MEM_LOGO_SRC =
  'https://files.tnonetwork.com/shows/logo/enproduccionconmem.png';

/** Logo Total Tools (tienda oficial). */
export const TOTAL_TOOLS_LOGO_SRC =
  'https://totaltoolsoficial.com.ve/wp-content/uploads/2025/07/logo-total-1-1.png';

/** Retrato de la conductora (perfil TNO). */
export const MARIA_EUGENIA_MORENO_PORTRAIT_SRC =
  'https://files.tnonetwork.com/users/profile/mariaeugenia.jpg';

/** Ficha del programa en TNO (biografía de la conductora, equipo y calendario). */
export const EN_PRODUCCION_CON_MEM_TNO_SHOW_URL =
  'https://www.tnonetwork.com/show/enproduccionconmem';
